import type { BoardBuilderProjections } from '@library/types/boardBuilder';
import type { CreateUpdateProjection } from '@library/types/projection';
import { usePublishProjectionsMutation } from '@bo-services/projectionsApi';

export const useBoardBuilderPublish = () => {
  const [publishProjections, more] = usePublishProjectionsMutation();

  const {
    error: publishProjectionsError,
    isError: isPublishProjectionsError,
    isSuccess: isPublishProjectionsSuccess,
    isUninitialized: isPublishProjectionsUninitialized,
    reset: resetPublishProjectionsApi
  } = more;

  const handlePublishProjections = async ({
    leagueId,
    projections
  }: {
    leagueId: string;
    projections: BoardBuilderProjections;
  }) => {
    const createUpdateProjections = projections.map((projection) => {
      const {
        autoTrade,
        boardTime: newBoardTime,
        durationId,
        gameId,
        gameModeIds,
        projectionId,
        rowStatus,
        description,
        leagueId: projectionLeagueId = leagueId,
        projectionValue,
        displayTime,
        startTime,
        statTypeId,
        player,
        inGame,
        maxProbabilityOfMore,
        minProbabilityOfMore,
        targetProbabilityOfMore
      } = projection;

      const boardTime = newBoardTime || startTime;

      const updateProjection: CreateUpdateProjection = {
        auto_trade: autoTrade,
        board_time: boardTime,
        description,
        duration_id: Number(durationId),
        game_id: gameId,
        game_mode_ids: gameModeIds?.map((gameModeId) => gameModeId),
        id: rowStatus === 'NEW' ? null : Number(projectionId),
        in_game: inGame,
        league_id: Number(projectionLeagueId),
        line_score: String(projectionValue),
        rank: projection.rank ? Number(projection.rank) : 0,
        start_time: startTime,
        display_time: displayTime,
        stat_type_id: Number(statTypeId),
        status: rowStatus === 'DELETED' ? 'removed' : projection.status,
        max_probability_of_more: maxProbabilityOfMore,
        min_probability_of_more: minProbabilityOfMore,
        target_probability_of_more: targetProbabilityOfMore
      };

      return {
        players: [player],
        projections: [updateProjection]
      };
    });

    await publishProjections({
      projections_request: createUpdateProjections
    });
  };

  return {
    handlePublishProjections,
    isPublishProjectionsError,
    isPublishProjectionsSuccess,
    isPublishProjectionsUninitialized,
    publishProjectionsError,
    resetPublishProjectionsApi
  };
};
